import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { createStyleSheet, formatAppointmentTime, getAppointmentColor } from '../../utils';
import { useStyleSheet, useThemeContext } from '../../hooks';
import { Text } from '../Text';
export const CalendarEvent = ({ onPress, id, status, subject, duration, time, style }) => {
    const { color } = useThemeContext();
    const styles = useStyleSheet(getStyles);
    const borderColor = getAppointmentColor(color, status);
    const handlePress = () => {
        onPress(id);
    };
    return (React.createElement(TouchableOpacity, { onPress: handlePress, style: [styles.container, style] },
        React.createElement(View, { style: [styles.indicatorBar, { backgroundColor: borderColor }] }),
        React.createElement(View, { style: styles.content },
            React.createElement(Text, { type: 'body', weight: 'regular', size: 'md' }, subject),
            React.createElement(Text, { type: 'body', weight: 'regular', size: 'md', style: styles.time }, formatAppointmentTime(time.toString(), duration)))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        flexDirection: 'row',
        height: size.M
    },
    indicatorBar: {
        width: size.B,
        borderRadius: size.D,
        backgroundColor: 'green'
    },
    content: {
        flex: 1,
        flexDirection: 'column',
        marginLeft: size.G,
        justifyContent: 'space-between'
    },
    time: { color: color.invert2.p56 }
}));
//# sourceMappingURL=index.js.map